import { format } from "date-fns";
import { FC } from "react";
import { Flex, HStack, Text } from "shared/components/Spor";
import { InfrastructureIncidentIcon24 } from "shared/icons/InfrastructureIncidentIcon24";

type EventChangesHeaderProps = {
  title: string;
  updatedAt: Date | string;
};

export const EventChangesHeader: FC<EventChangesHeaderProps> = ({
  title,
  updatedAt,
}) => (
  <Flex m="4" mb="3" gap="1" flexDirection="column">
    <Text fontWeight="bold" variant="md">
      Endringer på hendelse
    </Text>

    <HStack gap="1.5">
      <InfrastructureIncidentIcon24 />
      <Text fontWeight="bold" variant="sm">
        {title}
      </Text>
    </HStack>

    <Text variant="sm">
      Sist oppdatert {format(new Date(updatedAt), "HH:mm")}
    </Text>
  </Flex>
);
